<template>
  <div
    class="modal fade"
    id="sys_apply_pay_task_payment_modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
          <h4 class="modal-title" id="myModalLabel">
            收付款申请
          </h4>
        </div>

        <!-- modal-body-->
        <div class="modal-body">
          <div class="form-horizontal">

            <div class="form-group">
              <label class="col-sm-2 control-label">类型:</label>
              <div class="col-sm-4">
                <span v-if="payTask.type == 1">业主租金</span>
                <span v-if="payTask.type == 2">局方地租金</span>
                <span v-if="payTask.type == 3">局方杆租金</span>
                <span v-if="payTask.type == 4">业务协调费</span>
                <span v-if="payTask.type == 5">平台签约奖励</span>
                <span v-if="payTask.type == 6">杆塔资源费</span>
                <span v-if="payTask.type == 7">商务提成</span>
                (ID:{{payTask.id}})
              </div>
              <label class="col-sm-2 control-label">应结费金额:</label>
              <div class="col-sm-4">
                {{payTask.money}}
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">可结费时间:</label>
              <div class="col-sm-4">
                {{payTask.can_pay_time}}
              </div>
              <label class="col-sm-2 control-label">备注:</label>
              <div class="col-sm-4">
                {{payTask.remark}}
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">实际结费时间:</label>
              <div class="col-sm-4">
                <input
                  id="实际结费时间"
                  name="实际结费时间"
                  type="text"
                  v-model="form.实际结费时间"
                  class="form-control field"
                  @click="datePicker('实际结费时间')"
                />
              </div>
            </div>

          </div>
        </div>

        <!-- modal-footer -->
        <div class="modal-footer">
          <button type="button" data-dismiss="modal" class="btn btn-primary" @click="submit">确认</button>
          <button type="button" data-dismiss="modal" class="btn">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {datepicker} from 'eonasdan-bootstrap-datetimepicker'

export default {
  data() {
    return {
      payTask: {}, // 结费任务
      station: {}, // 基站信息
      form: { // 新增的结费任务表单
        '实际结费时间': ''
      }
    }
  },
  components: {datepicker},
  props: [],

  mounted: function () {
    let self = this
  },

  methods: {
    initFunc: function (payTask, station) {
      let self = this
      self.payTask = payTask
      self.station = station
      console.log('___initFunc 传入 payTask', payTask, 'station', station)
      $('#sys_apply_pay_task_payment_modal').modal('show') // 展示 modal 框
    },

    submit: function () { // 提交
      let self = this
      const org_id = JSON.parse(localStorage.getItem('companyInfo')).id

      const formData = {
        '公司ID': org_id,
        'station': self.station,
        ...self.form,
        payTask: self.payTask
      }
      console.log('___formData', formData)

      let checkPass = true
      if (!formData.实际结费时间)
        checkPass = false
      if (!checkPass) {
        alert('请将申请单填写完毕')
        return
      }

      self.global.axiosPost(self,
        'apply/8/',
        formData,
        function (res) {
          console.log('___resp', res)
          if (res.status === 'success') {
            alert('提交成功')
          }
        },
        function (response) {
          console.log('___提交失败')
          response.response && response.response.data.message && alert(response.response.data.message)
        }
      )

    },

    datePicker: function (elementId) {
      let self = this
      WdatePicker({
        el: elementId,
        dateFmt: 'yyyy-MM-dd HH:mm:ss', //日期格式，可以只显示年或年月，也可以额外显示时间
        onpicked: function () {
          var value = $('#' + elementId).val()
          console.log('___日期elementId', elementId, value)
          self.form[elementId] = value
        },
        oncleared: function () {
          self[elementId] = null
        },
        isShowClear: true,
        readOnly: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/applyWorkflow/applyPayTaskPaymentModal.vue